var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGm = function SvgIconGm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M12 0C7.04 0 2.782 3.012.954 7.306h22.093C21.219 3.011 16.96.001 12 .001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M12 24c4.961 0 9.219-3.01 11.047-7.304H.954C2.782 20.99 7.04 24.001 12 24.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M23.587 8.87H.413A12 12 0 0 0 0 12c0 1.083.144 2.132.413 3.13h23.174c.269-.998.413-2.047.413-3.13s-.144-2.132-.413-3.13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGm;